"use client";

import QRCode from "react-qr-code";

const DOWNLOAD_URL = "https://fastapp.dz/download";

export default function QRCodeWidget() {
  return (
    <div
      className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col items-center gap-2 rounded-2xl p-4"
      style={{ backgroundColor: "#fff", border: "1px solid rgba(0,0,0,0.08)", boxShadow: "0 8px 40px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.08)" }}
    >
      <p
        className="text-[10px] font-black uppercase tracking-widest"
        style={{ color: "var(--fast-secondary)" }}
      >
        Scan to download
      </p>
      <QRCode
        value={DOWNLOAD_URL}
        size={120}
        fgColor="#03331a"
        bgColor="#ffffff"
        style={{ display: "block" }}
      />
    </div>
  );
}
